<div class="background-form" *ngIf="appointment">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-3 p-0">
                <div class="client-info p-5">
                    <img src="assets/images/logo.png" alt="Diagnostic Learning Services Logo" width="150"
                        class="img-fluid mb-5">
                        <h4 class="text-grey">Appointment Information</h4>
                        <hr>
                    <div class="detail">
                        <ul>
                            <li>
                                <label>Name</label>
                                <p>{{appointment.clientName}}</p>
                            </li>
                            <li>
                                <label>Determination</label>
                                <p>{{appointment.schoolType}}</p>
                            </li>
                            <li>
                                <label>Type of Test</label>
                                <p>{{appointment.assessmentType}}</p>
                            </li>
                            <li>
                                <label>Appointment Date/Time</label>
                                <p>{{appointment.appointmentDate}} (CST)</p>
                            </li>
                            <li>
                                <label>Location</label>
                                <p>{{appointment.Location}}</p>
                            </li>
                            <li>
                                <label>Diagnostician</label>
                                <p>{{appointment.diagnosticianName}}</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-9 px-0">
                <div class="form bg-white p-4">

                    <div class="d-flex align-items-center">
                      
                    <h4 class="text-green">Assessment Information</h4>
                    <a class="theme-button ml-md-auto mr-2" (click)="printPage()">Print Form</a>
                    <a class="theme-button grey" href="javascript:close_window();">Back</a>


                </div>
                    <form class="custom-form">
                        <div id="questionsBank" class="input-outer rounded bg-theme-light py-3 mt-4">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-md-6">
                                      <label for="dateOfBirth">Date Of Birth *</label>
                                      <!-- <input type="text" readonly [value]="appointment.backgroundDetails.dateOfBirth | date :  'MM/dd/yyyy'" > -->
                                      <input type="text" readonly [value]="dob | date :  'MM/dd/yyyy'" >
                                     </div>
                                    <div class="col-md-6">
                                      <label for="currentSchool">Place of Employment/School *</label>
                                      <input type="text" [value]="appointment.backgroundDetails.currentSchool" readonly>
                                    </div>
                                  </div>
                            </div>
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-md-6">
                                        <label for="question16">Primary area of Concern/Reason for assessment *</label>
                                        <textarea [(ngModel)]="appointment.backgroundDetails.answer16" readonly name="answer16" rows="1"></textarea>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="question17">Additional area of Concern/Reason for assessment</label>
                                        <textarea [(ngModel)]="appointment.backgroundDetails.answer17" readonly name="answer17" rows="1"></textarea>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <label for="question1">Please elaborate on your choices above and tell us specifically what has led to your
                                    concerns. This can be your own observations as well as information from family members, professors,
                                    coworkers, or other professionals you have worked with. (Please be as specific as possible, this
                                    information will help us plan for your assessment) *</label>
                                <textarea [(ngModel)]="appointment.backgroundDetails.answer1" readonly  name="answer1" class="" id=""
                                    rows="3"></textarea>

                            </div>
                            <div class="col-12">
                                <label for="question2">How have these issues impacted your performance at school/work? *</label>
                                <textarea [(ngModel)]="appointment.backgroundDetails.answer2" readonly name="answer2" rows="3"></textarea>
                            </div>
                            <div class="col-12">
                                <label for="question3">If you have ever been diagnosed with any type of learning disability, ADHD,
                                    speech/language impairment, or physical disability, please indicate the type of diagnosis you have
                                    received.</label>
                                <textarea [(ngModel)]="appointment.backgroundDetails.answer3" readonly  name="answer3" rows="3"></textarea>

                            </div>
                            <div class="col-12">
                                <label for="question4">Have you ever received support through any of the following programs? *</label>
                                <textarea [(ngModel)]="appointment.backgroundDetails.answer4" readonly name="answer4" rows="1"></textarea>
                            </div>
                            <div class="col-12">
                                <label for="question5">If so, please tell us the type of support you received and what specific
                                    accommodations
                                    were provided for you.</label>
                                <textarea [(ngModel)]="appointment.backgroundDetails.answer5" readonly name="answer5" rows="3"></textarea>
                            </div>
                            <div class="col-12">
                                <label for="question6">What do you hope to learn from this assessment? What do you plan to use this
                                    information
                                    for? *</label>
                                <textarea [(ngModel)]="appointment.backgroundDetails.answer6" readonly  name="answer6" rows="3"></textarea>
                            </div>
                            <div class="col-12">
                                <label for="question7">Do you have any medical conditions or are you currently taking any medications?
                                    *</label>
                                <textarea rows="3" readonly  name="answer7" [(ngModel)]="appointment.backgroundDetails.answer7"></textarea>
                            </div>
                            <div class="col-12">
                                <label for="question8">Do you have a family history of any Learning Disabilities, ADHD, Depression, or
                                    Anxiety?
                                    *</label>
                                <textarea rows="3" readonly  name="answer8" [(ngModel)]="appointment.backgroundDetails.answer8"></textarea>
                            </div>
                            <div class="col-12">
                                <label for="question9">How would you describe your performance when you were in elementary school? *</label>
                                <textarea rows="3" readonly  name="answer9" [(ngModel)]="appointment.backgroundDetails.answer9"></textarea>
                            </div>
                            <div class="col-12">
                                <label for="question10">What about Middle and High School? *</label>
                                <textarea rows="3" readonly  name="answer10" [(ngModel)]="appointment.backgroundDetails.answer10"></textarea>
                            </div>
                            <div class="col-12">
                                <label for="question11">If you are attending college, or attended in the past, describe your
                                    performance.</label>
                                <textarea rows="3" readonly  name="answer11" [(ngModel)]="appointment.backgroundDetails.answer11"></textarea>
                            </div>
                            <div class="col-12">
                                <label for="question12">Over the course of your school career, what subjects or classes were usually the
                                    easiest for
                                    you? *</label>
                                <textarea rows="3" readonly  name="answer12" [(ngModel)]="appointment.backgroundDetails.answer12"></textarea>
                            </div>
                            <div class="col-12">
                                <label for="question13">What subjects or classes did you find to be more challenging? *</label>
                                <textarea rows="3" readonly  name="answer13" [(ngModel)]="appointment.backgroundDetails.answer13"></textarea>
                            </div>
                        </div>
                        <div id="checkboxBank" class="checkbox-outer rounded bg-theme-light py-3 mt-4">
                            <div class="col-12">
                                <h5>Please indicate your level of concern for each of the following behaviors: *</h5>
                            </div>
                            <div class="col-12">
                                <div class="bg-white border rounded table-responsive mt-4">
                                    <table class="bg-white">
                                        <thead>
                                            <tr>
                                                <th>List of concerns</th>
                                                <th>No Concerns</th>
                                                <th>Mild Concerns</th>
                                                <th>Definite Concerns</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr id="1">
                                                <td>Concentrate when reading</td>

                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" [attr.disabled]="true" name="concentrateWhenReading" 
                                                            [checked]="appointment.backgroundDetails.concentrateWhenReading==1"
                                                            class="custom-control-input" value="1">
                                                        <label class="custom-control-label"
                                                            for="concentrateWhenReading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="concentrateWhenReading"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.concentrateWhenReading==2"
                                                            class="custom-control-input" value="2">
                                                        <label class="custom-control-label"
                                                            for="concentrateWhenReading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="concentrateWhenReading" [attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.concentrateWhenReading==3"
                                                            class="custom-control-input">
                                                        <label class="custom-control-label" for="concentrateWhenReading"
                                                            value="3"></label>
                                                    </div>
                                                </td>
                                            </tr>


                                            <tr id="1">
                                                <td>Avoid distractions</td>

                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="avoidDistractions"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.avoidDistractions==1"
                                                            class="custom-control-input" value="1">
                                                        <label class="custom-control-label"
                                                            for="avoidDistractions"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="avoidDistractions"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.avoidDistractions==2"
                                                            class="custom-control-input" value="2">
                                                        <label class="custom-control-label"
                                                            for="avoidDistractions"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="avoidDistractions"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.avoidDistractions==3"
                                                            class="custom-control-input">
                                                        <label class="custom-control-label" for="avoidDistractions"
                                                            value="3"></label>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr id="1">



                                                <td>Pay attention to a boring task</td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="payAttentionInBoringClass"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.payAttentionInBoringClass==1"
                                                            class="custom-control-input" value="1">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="payAttentionInBoringClass"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.payAttentionInBoringClass==2"
                                                            class="custom-control-input" value="2">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="payAttentionInBoringClass"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.payAttentionInBoringClass==3"
                                                            class="custom-control-input">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading" value="3"></label>
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr id="1">
                                                <td>Think before acting</td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="thinkBeforeAct"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.thinkBeforeAct==1"
                                                            class="custom-control-input" value="1">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="thinkBeforeAct"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.thinkBeforeAct==2"
                                                            class="custom-control-input" value="2">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="thinkBeforeAct"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.thinkBeforeAct==3"
                                                            class="custom-control-input">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading" value="3"></label>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr id="1">
                                                <td>Wait for your turn</td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="waitForTurn"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.waitForTurn==1"
                                                            class="custom-control-input" value="1">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="waitForTurn"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.waitForTurn==2"
                                                            class="custom-control-input" value="2">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="waitForTurn"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.waitForTurn==3"
                                                            class="custom-control-input">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading" value="3"></label>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr id="1">
                                                <td>Start something withour being asked</td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="startWithoutAsked"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.startWithoutAsked==1"
                                                            [attr.disabled]="true"
                                                            class="custom-control-input" value="1">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="startWithoutAsked"[attr.disabled]="true"
                                                        [attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.startWithoutAsked==2"
                                                            class="custom-control-input" value="2">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="startWithoutAsked"[attr.disabled]="true"
                                                        [attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.startWithoutAsked==3"
                                                            class="custom-control-input">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading" value="3"></label>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr id="1">
                                                <td>Complete one task before starting a new one</td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="completeTask"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.completeTask==1"
                                                            class="custom-control-input" value="1">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="completeTask"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.completeTask==2"
                                                            class="custom-control-input" value="2">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="completeTask"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.completeTask==3"
                                                            class="custom-control-input">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading" value="3"></label>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr id="1">
                                                <td>Get and stay organised</td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="stayOrganised"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.stayOrganised==1"
                                                            class="custom-control-input" value="1">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="stayOrganised"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.stayOrganised==2"
                                                            class="custom-control-input" value="2">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"name="stayOrganised"[attr.disabled]="true"
                                                            [checked]="appointment.backgroundDetails.stayOrganised==3"
                                                            class="custom-control-input">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading" value="3"></label>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr id="1">
                                                <td>Keep track of time</td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" name="keepTrackOfTime"[attr.disabled]="true" class="custom-control-input" 
                                                        [checked]="appointment.backgroundDetails.keepTrackOfTime==1" value="1">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" [checked]="appointment.backgroundDetails.keepTrackOfTime==2" [attr.disabled]="true"name="keepTrackOfTime"class="custom-control-input" value="2">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" [checked]="appointment.backgroundDetails.keepTrackOfTime==3"[attr.disabled]="true" name="keepTrackOfTime" class="custom-control-input">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading" value="3"></label>
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr id="1">
                                                <td>Remember instructions</td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" [checked]="appointment.backgroundDetails.rememberInstructions==1"[attr.disabled]="true" name="rememberInstructions" class="custom-control-input" value="1">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"[checked]="appointment.backgroundDetails.rememberInstructions==2"[attr.disabled]="true" name="rememberInstructions" class="custom-control-input" value="2">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" [checked]="appointment.backgroundDetails.rememberInstructions==3"[attr.disabled]="true" name="rememberInstructions" class="custom-control-input">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading" value="3"></label>
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr id="1">
                                                <td>Remember what you have read</td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" [checked]="appointment.backgroundDetails.rememberRead==1" [attr.disabled]="true"name="rememberRead"class="custom-control-input" value="1">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio"[checked]="appointment.backgroundDetails.rememberRead==2"[attr.disabled]="true" name="rememberRead" class="custom-control-input" value="2">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" [checked]="appointment.backgroundDetails.rememberRead==3"[attr.disabled]="true" name="rememberRead" class="custom-control-input">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading" value="3"></label>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr id="1">
                                                <td>Control emotions under stress</td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" [checked]="appointment.backgroundDetails.controlEmotions==1"[attr.disabled]="true" name="controlEmotions" class="custom-control-input" value="1">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" [checked]="appointment.backgroundDetails.controlEmotions==2"[attr.disabled]="true" name="controlEmotions" class="custom-control-input" value="2">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading"></label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="custom-control custom-radio">
                                                        <input type="radio" [checked]="appointment.backgroundDetails.controlEmotions==3"[attr.disabled]="true" name="controlEmotions"class="custom-control-input">
                                                        <label class="custom-control-label"
                                                            for="Concentrate_when_reading" value="3"></label>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div id="otherImformation" class="input-outer rounded bg-theme-light py-3 mt-4">
                            <div class="col-12">
                                <label for="question14">Please tell us what kinds of things you enjoy doing outside of school/work? *</label>
                                <textarea [(ngModel)]="appointment.backgroundDetails.answer14" readonly  name="answer14" class="" id="" rows="3"></textarea>
                            </div>
                            <div class="col-12">
                                <label for="question15">Is there any other information that you think will be helpful to the professionals that will be working with you?</label>
                                <textarea [(ngModel)]="appointment.backgroundDetails.answer15" readonly  name="answer15" class="" id="" rows="3"></textarea>
                            </div>
                            <div class="col-12">
                                <label for="backgroundFormComment">Referred By *</label>
                                <textarea [(ngModel)]="appointment.backgroundDetails.backgroundFormComment" name="backgroundFormComment" readonly rows="3"></textarea>
                            </div>
                            <div class="col-12 mt-4">
                                <div class="row">
                                    <div class="col-md-6">
                                        <label>Name of Individual submitting this information</label>
                                        <input type="text" readonly [value]="appointment.backgroundDetails.submitterName || appointment.backgroundDetails.formFilledBy || '-'" class="form-control bg-light">
                                    </div>
                                    <div class="col-md-6">
                                        <label>Submission Date</label>
                                        <input type="text" readonly [value]="appointment.backgroundDetails.submissionDate || '-'" class="form-control bg-light">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>